export const TICK_RATE = 60;
export const FIXED_DT_SECONDS = 1 / TICK_RATE;
export const FIXED_TICK_MS = 1000 / TICK_RATE;
export const PHYSICS_VERSION = "air-hockey-physics-v1";
export const PROTOCOL_VERSION = "air-hockey-protocol-v1";
export const PLAYER_SLOTS = ["PLAYER_A", "PLAYER_B"];
//# sourceMappingURL=types.js.map